module.exports = "data:image/png;base64,"


//////////////////
// WEBPACK FOOTER
// ./src/assets/man_unsplash_OH2S9XAcLhc.png
// module id = HcGF
// module chunks = 1